/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/**
 * 品牌介绍以及部分用户使用指南引导
 */
import { CreditDataType } from '@/api/homeV2Status/types';
import { RouterV2Enum } from '@/router/router-names';
import platform from '@/shared/utils/platform';
import store from '@/store';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const style: Dictionary = require('./index.module.scss');

const HomeStore = namespace('home');
@Component
export default class BrandGuide extends Vue {
  @HomeStore.State creditData!: CreditDataType | null;

  // 用于埋点中记录具体的页面
  @Prop({
    type: String,
    required: true,
  }) readonly pageName: string = '';

  // 是否授信过
  private get hasCredit(): boolean {
    return !!this.creditData && this.creditData.creditStatus;
  }

  private get userInfomation() {
    return platform.isAlipayMini && !store.state.base.originUserInfo.token;
  }

  private render() {
    return (
      <div class={style.brandGuide}>
        <div class={style.brandGuideTop}>
          <div class={style.brandName}>臻有钱</div>
          <div class={style.features}>合规专业 精准推荐 权威合作</div>
        </div>
        <div class={[style.guideLine, this.hasCredit && style.hasCredit]}>
          <span
            class={style.guideItem}
            onClick={this.showCreditGuide.bind(this)}
          >授信指南</span>
          <span class={style.guideItem} onClick={this.showDrawGuide.bind(this)}>如何提现</span>
          <span class={style.guideItem} onClick={this.showRepayGuide.bind(this)}>如何还款</span>
        </div>
      </div>
    );
  }

  private showCreditGuide() {
    this.showUsingGuidePage('finance_grant_credit', 0);
  }

  private showDrawGuide() {
    this.showUsingGuidePage('finance_widthraw', 1);
  }

  private showRepayGuide() {
    this.showUsingGuidePage('finance_pay_money', 2);
  }

  private showUsingGuidePage(ubtName: string, queryIndex: number | string) {
    if (this.userInfomation) {
      return;
    }
    this.$ubtPageButton(ubtName, 'label', this.pageName);

    this.$router.push({
      path: RouterV2Enum.usingGuid,
      query: {
        index: String(queryIndex),
      },
    });
  }
}
